// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"SectionF_TheComp__HI6es","TheComp2":"SectionF_TheComp2__MTVw5"};